var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[_c('v-img',{staticClass:"me-2",attrs:{"src":require('../../assets/' + _vm.image),"max-width":"22"}}),_c('ui-subtitle',{attrs:{"subtitle":_vm.subtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }